import React from "react"
import { Link, useStaticQuery, graphql  } from "gatsby"
import fbLogo from "../../images/facebook.svg"
import InstaLogo from "../../images/instagram.svg"
import PinterestLogo from "../../images/PinterestLogo.svg"

const Footer = ({ columns }) => {
  const { dataJson } = useStaticQuery(
    graphql`
    query FooterQuery {
      dataJson(content_type: {eq: "footer"}) {
        facebook_link
        instagram_link
        Pinterest_link
        kolonne_1 {
          link
          link_title
          template
          link_type
        }
        kolonne_2 {
          link
          link_title
          template
          link_type
        }
        kolonne_3 {
          link
          link_title
          template
          link_type
        }
        tekst_bund
      }
    }
    `
  )

  return (
  <footer className="bg-lightgreen section">
    <div className="container">
      <div className="row space-xs-up">
        <div className="col col-xs-12 col-lg-3 text-center space-xs-up">
          <a className="footer-icon" href={ dataJson.facebook_link } target="_blank"  rel="noopener noreferrer"><img className="some-icon" src={fbLogo} alt="Facebook logo" /></a>
          <a className="footer-icon" href={ dataJson.instagram_link } target="_blank" rel="noopener noreferrer"><img className="some-icon" src={InstaLogo} alt="Instagram logo" /></a>
          <a className="footer-icon" href={ dataJson.Pinterest_link } target="_blank" rel="noopener noreferrer"><img className="some-icon" src={PinterestLogo} alt="Pinterest logo" /></a>
        </div>
        <div className="col col-xs-12 col-lg-3 text-center space-xs-up">
          { dataJson.kolonne_1.map((item, i) => (
            item.template === 'link-footer' && item.link_type === 'Internt' ?
            <Link key={i} to={item.link}>{ item.link_title }</Link>
            : item.template === 'link-footer' && item.link_type === 'Eksternt' ?
            <a key={i} href={item.link} target="_blank"rel="noopener noreferrer" className="text-decoration-none">{ item.link_title }</a>
            : null
          ))}
        </div>
        <div className="col col-xs-12 col-lg-3 text-center space-xs-up">
        { dataJson.kolonne_2.map((item, i) => (
            item.template === 'link-footer' && item.link_type === 'Internt' ?
            <Link key={i} to={item.link}>{ item.link_title }</Link>
            : item.template === 'link-footer' && item.link_type === 'Eksternt' ?
            <a key={i} href={item.link} target="_blank" rel="noopener noreferrer" className="text-decoration-none">{ item.link_title }</a>
            : null
          ))}
        </div>
        <div className="col col-xs-12 col-lg-3 text-center space-xs-up">
        { dataJson.kolonne_3.map((item, i) => (
            item.template === 'link-footer' && item.link_type === 'Internt' ?
            <Link key={i} to={item.link}>{ item.link_title }</Link>
            : item.template === 'link-footer' && item.link_type === 'Eksternt' ?
            <a key={i} href={item.link} target="_blank" rel="noopener noreferrer" className="text-decoration-none">{ item.link_title }</a>
            : null
          ))}
        </div>
      </div>
      <div className="row">
        <div className="col col-xs-12 text-center">
          <p className="small">{ dataJson.tekst_bund }</p>
        </div>
      </div>
    </div>
  </footer>
)}

export default Footer
